export const PLAY = 'PLAY';
export const RESET = 'RESET';
export const GAMESTATUS = 'GAMESTATUS';
export const CREATE_COLUMN = 'CREATE_COLUMN';
export const DELETE_COLUMN = 'DELETE_COLUMN';
export const CREATE_TASK = 'CREATE_TASK';
export const ITEMDRAG = 'ITEMDRAG';
export const ITEM_DRAG_NEXT_COL = 'ITEM_DRAG_NEXT_COL';